import { SearchComponent } from "../components/searchComponent"

export const ArticlesPage = () => {
  document.title = "SKU"
  return (<SearchComponent page="sku" />)
}